import { AlertTriangleFilled, InfoCircle, InfoCircleFilled } from "@imwebme/clay-icons";

export const iconMap = {
  default: <InfoCircle size="large" colorToken="icon-sub" />,
  critical: <AlertTriangleFilled size="large" colorToken="icon-critical" />,
  warning: <AlertTriangleFilled size="large" colorToken="icon-warning" />,
  information: <InfoCircleFilled size="large" colorToken="icon-accent" />,
};
